enum PrimaryDocumentTypeEnum {
    IDENTITY_CARD = "IDENTITY_CARD",
    RESIDENCE_PERMIT = "RESIDENCE_PERMIT",
}

export default PrimaryDocumentTypeEnum;
